

import { API, axiosInstance } from "lib";

export const getfastagListApi = (data={}) => {
    return axiosInstance
      .post(API.FASTAGS_LIST , data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          return err?.response?.data
        }
        
      });
  };

  export const getfastagDetailsApi = (data={}) => {
    return axiosInstance
      .post(API.FASTAG_DETAILS , data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          return err?.response?.data
        }
        
      });
  };

  export const getfastagTransactionListApi = (data={}) => {
    return axiosInstance
      .post(API.FASTAG_TRANSACTION , data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          return err?.response?.data
        }
        
      });
  };

   export const assignTransactionApi = (data={}) => {
    return axiosInstance
      .post(API.ASSIGN_TRANSACTION , data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          return err?.response?.data
        }
        
      });
  };

  

  